import React from 'react'
import Form1040 from '../forms/Form1040'
import Form1065 from '../forms/Form1065'
import Form1120 from '../forms/Form1120'
import Form1120S from '../forms/Form1120S'

export default ({ form, year, onDataChange, defaults }) => {
  const commonProps = { defaults, onDataChange, year }
  switch (form) {
    case '1040C':
      return <Form1040 {...commonProps} />
    case '1065':
      return <Form1065 {...commonProps} />
    case '1120':
      return <Form1120 {...commonProps} />
    case '1120S':
      return <Form1120S {...commonProps} />
    default:
      return null
  }
}